import { ComposeViewState, ExcludedPluginsForMail } from 'owa-mail-compose-store';
import { ExcludedPlugins } from 'owa-editor-plugins-list';

type ComposePlugins = ExcludedPlugins<ExcludedPluginsForMail>;

export default ComposePlugins;

const pluginMap: { [key: number]: ComposePlugins } = {};

export function addComposePlugins(viewState: ComposeViewState, plugins: ComposePlugins) {
    pluginMap[viewState.composeId] = plugins;
}

export function findComposePlugins(viewState: ComposeViewState): ComposePlugins {
    return pluginMap[viewState.composeId];
}

export function removeComposePlugins(viewState: ComposeViewState) {
    const plugins = findComposePlugins(viewState);
    if (plugins && plugins.contentOperation) {
        // We are removing all the plugins, stop auto save since we don't need that now.
        plugins.contentOperation.stopSaveOnDispose();
    }
    delete pluginMap[viewState.composeId];
}
